export enum ChipInputKeyCodes {
  Backspace = 'Backspace',
  Enter = 'Enter',
  Space = 'Space',
}
